import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import createBrowserHistory from 'history/createBrowserHistory'
import "./styles/index.css";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";
import { AUTH_TOKEN } from "./constants";
import { split } from "apollo-link";
import { WebSocketLink } from "apollo-link-ws";
import { getMainDefinition } from "apollo-utilities";

import * as Sentry from "@sentry/browser";
Sentry.init({
  dsn:
    "https://6e66063b5b084f38a3bfe236cf7cdda6@o407010.ingest.sentry.io/5287241",
});

const httpLink = createHttpLink({
  uri:
    process.env.REACT_APP_ENV === "production"
      ? "https://ml-news.herokuapp.com"
      : "http://localhost:4000",
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const wsLink = new WebSocketLink({
  uri:
    process.env.REACT_APP_ENV === "production"
      ? "wss://ml-news.herokuapp.com"
      : "ws://localhost:4000",
  options: {
    reconnect: true,
    connectionParams: {
      authToken: localStorage.getItem(AUTH_TOKEN),
    },
  },
});

const link = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === "OperationDefinition" && operation === "subscription";
  },
  wsLink,
  authLink.concat(httpLink)
);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    dataIdFromObject: (o) => (o._id ? `${o.__typename}:${o._id}` : null),
  }),
});

const newHistory = createBrowserHistory();

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter history={newHistory}>
      <App />
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById("root")
);
serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js